import { createContext } from "react";
import { createDefaultContext } from "../../../helpers/createDefaultContext";

export type TooltipContextValue = {
  disabled?: boolean;
  open: boolean;
  setOpen: (open: boolean) => void;
  tooltipId?: string;
  triggerRef: React.RefObject<HTMLElement | null>;
};

export const TooltipContext = createContext<TooltipContextValue>(
  createDefaultContext(),
);
